import { render } from "./ComingSoonView.vue.ts?vue&type=template&id=972f69ba&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ComingSoonView.vue?vue&type=template&id=972f69ba&scoped=true&ts=true"
import script from "./ComingSoonView.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ComingSoonView.vue?vue&type=script&lang=ts"
export * from "./ComingSoonView.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ComingSoonView.vue?vue&type=script&lang=ts"

import "./ComingSoonView.vue.scss?vue&type=style&index=0&id=972f69ba&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ComingSoonView.vue?vue&type=style&index=0&id=972f69ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-972f69ba"],['__file',"src/apps/core-app-onboarding/views/ComingSoonView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "972f69ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('972f69ba', __exports__)) {
    api.reload('972f69ba', __exports__)
  }
  
  module.hot.accept("./ComingSoonView.vue.ts?vue&type=template&id=972f69ba&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./ComingSoonView.vue?vue&type=template&id=972f69ba&scoped=true&ts=true", () => {
    api.rerender('972f69ba', render)
  })

}


export default __exports__